module.exports = __webpack_public_path__ + "static/img/m3.5c33e82.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark-edge/mobile/m3.png
// module id = dWps
// module chunks = 12